<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20">
    <g fill="none" fill-rule="evenodd" transform="translate(0 .318)">
      <circle cx="9" cy="9.682" r="8.5" :stroke="color" />
      <circle cx="9" cy="9.682" r="2.5" :stroke="color" />
      <path
        :fill="color"
        d="M12.596 10.778H13.596V16.778H12.596z"
        transform="rotate(-45 13.096 13.778)"
      />
      <path :fill="color" d="M4.975 3.157H5.975V9.157H4.975z" transform="rotate(-45 5.475 6.157)" />
      <path :fill="color" d="M11.818 -1H12.818V13H11.818z" transform="rotate(-45 12.318 6)" />
      <path
        :fill="color"
        d="M4.889 6.071H5.889V20.070999999999998H4.889z"
        transform="rotate(-45 5.39 13.071)"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: String,
  },
};
</script>
